import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { Container } from 'components/qstrap'
import Details from './Details'
import Example from './Example'

const InlineWrapper = ({ factor }) => (
  <div id="aptitude-answering-instructions">
    <Container>
      <br />
      <Details factor={factor} />

      <hr />

      <div className="m-y-md text-center"><b>{intl.get('aptitude.questions.bar.example')}</b></div>

      <Example factor={factor} />

      <div className="m-y-md text-center"><b>{intl.get('aptitude.instructions.good_luck')}</b></div>
    </Container>
  </div>
)

InlineWrapper.propTypes = {
  factor: PropTypes.string.isRequired,
}

export default InlineWrapper
